<template>
  <div v-if="display" class="pb-3">
    <div class="child-row-item__title">Cost</div>
    <div class="child-row-item__subtitle">
      <span class="cost-value">{{ formattedPrice(shipment.actualPrice) }}</span>
      <small class="text-muted">
        <s>{{ formattedPrice(shipment.initialPrice) }}</s>
      </small>
    </div>
  </div>
</template>

<script lang="ts">
import type { Shipment } from '@/types/Models/Shipment'
import { defineComponent, computed, type PropType, type ComputedRef } from 'vue'
import { formattedPrice } from '@/services/Helpers'
import { useAccountStore } from '@/store/account'

export default defineComponent({
  name: 'ShipmentCost',
  props: {
    shipment: {
      type: Object as PropType<Shipment>,
      required: true,
    },
  },
  setup(props) {
    const accountStore = useAccountStore()

    const isStaff: ComputedRef<boolean> = computed(() => accountStore.isStaff)
    const hidePrices: ComputedRef<boolean> = computed(() => !isStaff.value && props.shipment?.company?.hidePrice)
    const display: ComputedRef<boolean> = computed(() => isStaff.value || !hidePrices.value)

    return {
      isStaff,
      hidePrices,
      display,
      formattedPrice,
    }
  },
})
</script>
